{
  "loading": "Cargando…",
  "placeholder": "Selecciona una de estas opciones..."
}
